import { Component, Input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { environment } from '@/app/environments/environment';
import { DateFormatService } from '@/app/services/date-format.service';
import { AttachmentListComponent } from '../../../../../../attachment-list/attachment-list.component';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';

@Component({
  selector: 'app-pqq-read-only-form',
  standalone: true,
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    AttachmentListComponent,
  ],
  templateUrl: './pqq-read-only-form.component.html',
  styleUrl: './pqq-read-only-form.component.css',
})
export class PqqReadOnlyFormComponent {
  pqqId: number;
  responseId: number;
  constructor(
    public DateFormatService: DateFormatService,
    private getFileIconService: GetFileIconUtilityService
  ) {}

  @Input() responseSubmitted: any;

  baseUrl = environment.storageUrl;

  isImageFile(filePath: string | undefined): boolean {
    if (!filePath) return false;
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
  }

  isPdfFile(filePath: string | undefined): boolean {
    if (!filePath) return false;
    return /\.pdf$/i.test(filePath);
  }

  getFileUrl(filePath: string | undefined): string {
    return filePath ? `${this.baseUrl}${filePath}` : '';
  }

  openPdf(url: string): void {
    if (url) {
      window.open(url, '_blank'); // Opens the PDF in a new tab
    } else {
      console.error('PDF URL is invalid or undefined.');
    }
  }
  getFileIcon(filePath: string): string {
    const extension = filePath.split('.').pop() || '';
    return this.getFileIconService.getFileTypeFromMime(extension);
  }
}
